import {
  Component,
  computed,
  DestroyRef,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core'
import { AccountInfo } from '@azure/msal-browser'
import { UserManagementService } from '../../service/user-management.service'
import { AuthService } from '../../service/auth.service'
import { Subject, first, tap } from 'rxjs'
import { HttpErrorResponse } from '@angular/common/http'
import { GroupComponent } from '../group/group.component'
import { Permissions } from '../enums/permissions.enum'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [GroupComponent],
})
export class HomeComponent implements OnInit, OnDestroy {
  _destroying$ = new Subject<void>()
  public isLoggedIn = computed(() => this.authService.loginDisplay())
  public getUserMessage = signal('Loading...')
  public adminPermissions = signal<string[]>([])
  private destroyRef = inject(DestroyRef)

  constructor(
    private authService: AuthService,
    public readonly userManagementService: UserManagementService,
  ) {}

  public async ngOnInit(): Promise<void> {
    const subscription = this.authService.activeAccountChanges
      .pipe()
      .subscribe((account: AccountInfo) => {
        const permissions = ((account.idTokenClaims as any).permissions ||
          []) as string[]
        const products = ((account.idTokenClaims as any).products ||
          []) as string[]
        const filteredPermissions = permissions.filter((permission) =>
          products
            .map((p) => `${p}.admin`)
            .some((allowed) => permission === allowed),
        )
        this.adminPermissions.set(filteredPermissions)
        this.getUser(account)
      })
    this.destroyRef.onDestroy(() => {
      subscription.unsubscribe()
    })
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined)
    this._destroying$.complete()
  }

  public async getUser(account: AccountInfo) {
    const response = this.userManagementService.getUser().subscribe({
      error: (err: HttpErrorResponse) => {
        this.getUserMessage.set(`Unable to load users!`)
      },
    })
  }
}
